import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { useOrg } from "./session";

// Which outside platforms this company uses (chosen by SVENEX on its
// industry template). Until it loads, everything counts as on, so nothing
// flickers away for the many companies that have them all.

export interface IntegrationInfo { key: string; name: string; group: string; description: string }

export function useIntegrations() {
  const { base, orgId } = useOrg();
  const q = useQuery({
    queryKey: [orgId, "integrations"],
    queryFn: () => api<{ all: boolean; enabled: string[]; catalog: IntegrationInfo[] }>(`${base}/integrations`),
    staleTime: 5 * 60_000,
  });
  const has = (key: string) => !q.data || q.data.all || q.data.enabled.includes(key);
  return { ...q, has };
}

/** The platforms SVENEX connects to (the same list as the server's). */
export const integrationCatalog: IntegrationInfo[] = [
  { key: "web_chat", name: "Website chat", group: "Conversations", description: "The AI agent on the company's website, and a chat link to share." },
  { key: "whatsapp", name: "WhatsApp", group: "Conversations", description: "Customers message the company's WhatsApp number and the AI agent answers." },
  { key: "gmail", name: "Gmail", group: "Email", description: "A Gmail or Google Workspace mailbox in the inbox." },
  { key: "outlook_mail", name: "Outlook mail", group: "Email", description: "An Outlook or Microsoft 365 mailbox in the inbox." },
  { key: "google_calendar", name: "Google Calendar", group: "Calendars", description: "Bookings appear in Google Calendar, and busy times there block bookings." },
  { key: "outlook_calendar", name: "Outlook Calendar", group: "Calendars", description: "Bookings appear in Outlook Calendar, and busy times there block bookings." },
];

/** IntegrationPicker: tick the platforms. null means "all of them". */
export type IntegrationList = string[] | null;
